import { useInfiniteQuery } from '@tanstack/react-query';
import { chatService } from '../services/chatService';

export function useSessions(workspaceId: string | undefined) {
  return useInfiniteQuery({
    queryKey: ['sessions', workspaceId],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await chatService.listSessions(workspaceId, pageParam, 20);
      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch sessions');
      }
      return {
        sessions: response.data ?? [],
        pagination: response.pagination,
      };
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage.pagination;
      if (!pagination) return undefined;
      return pagination.page < pagination.totalPages
        ? pagination.page + 1
        : undefined;
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!workspaceId,
  });
}
